"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const react_1 = require("react");
/**
 * custom hook to update the link with web client id on client side
 */
function useLinkWithWcid(link) {
    const webClientId = (0, web_sc_cookies_1.useGetWebClientId)();
    const [linkWithWcid, setLinkWithWcid] = (0, react_1.useState)(link);
    (0, react_1.useEffect)(() => {
        const currentURL = new URL(link);
        const searchParams = new URLSearchParams(currentURL.search);
        if (webClientId) {
            searchParams.set("web_client_id", webClientId || "");
        }
        currentURL.search = searchParams.toString();
        setLinkWithWcid(currentURL.toString());
    }, [link, webClientId]);
    return linkWithWcid;
}
exports.default = useLinkWithWcid;
//# sourceMappingURL=useLinkWithWcid.js.map